<template>
  <div id="map" style="min-height: 600px" />
</template>
<script>
import { setOptions, importLibrary } from "@googlemaps/js-api-loader";

export default {
  props: {
    apiKey: { type: String, required: true },
    center: { type: Object },
    markers: { type: Array },
    zoom: { type: Number, default: 10 },
    circles: { type: Array },
  },
  emits: ["buyer-hover", "buyer-hover-leave", "directions-rendered"],
  data() {
    return {
      map: null,
      loading: true,
      mapMarker: [],
      popups: [],
      directions: null,
      directionsRenderer: null,
      mapCircles: [],
      circleInstances: [],
    };
  },
  mounted() {
    setOptions({ apiKey: this.apiKey, version: "quarterly" });
    this.loadMap();
  },
  methods: {
    async loadMap() {
      const { Map, InfoWindow, Circle } = await importLibrary("maps");
      const { Marker, Animation } = await importLibrary("marker");
      const { LatLng, Size } = await importLibrary("core");
      const { DirectionsService, DirectionsRenderer } = await importLibrary("routes");

      this.directions = new DirectionsService();
      this.directionsRenderer = new DirectionsRenderer();
      this.map = new Map(document.getElementById("map"), {
        center: this.center ? { lat: this.center.lat, lng: this.center.lng } : new LatLng(39.8283, -98.5795),
        zoom: this.center ? this.zoom : 4.5,
        mapTypeControl: false,
        scaleControl: false,
      });

      this.map.addListener("click", () => {
        this.markers.forEach((marker) => {
          this.popups[marker.id]?.close();
        });
      });

      this.buildCircles();

      if (this.markers && this.markers.length > 0) {
        this.markers.forEach((marker) => {
          this.mapMarker[marker.id] = new Marker({
            position: marker.position,
            title: marker.title,
            animation: Animation.DROP,
          });

          if (marker.popupContent) {
            this.popups[marker.id] = new InfoWindow({
              content: marker.popupContent,
            });

            this.mapMarker[marker.id].addListener("click", () => {
              this.markers.forEach((m) => {
                this.popups[m.id]?.close();
              });
              this.popups[marker.id].open(this.map, this.mapMarker[marker.id]);
            });

            this.mapMarker[marker.id].addListener("mouseover", () => {
              this.$emit("buyer-hover", true);
            });

            this.mapMarker[marker.id].addListener("mouseout", () => {
              this.$emit("buyer-hover-leave", true);
            });
          }

          if (marker.icon && marker.icon.url) {
            const markerId = marker.id;
            const iconUrl = marker.icon.url;
            const img = new Image();
            img.onload = () => {
              this.mapMarker[markerId]?.setIcon({
                url: iconUrl,
                scaledSize: new Size(40, 40),
              });
            };
            img.src = iconUrl;
          }

          this.mapMarker[marker.id].setMap(this.map);
        });
      }

      if (this.circles && this.circles.length > 0) {
        this.circles.forEach((circle) => {
          const circleInstance = new Circle({
            strokeColor: circle.strokeColor,
            strokeOpacity: circle.strokeOpacity,
            strokeWeight: circle.strokeWeight,
            fillColor: circle.fillColor,
            fillOpacity: circle.fillOpacity,
            map: this.map,
            center: circle.center,
            radius: circle.radius,
          });

          this.circleInstances.push(circleInstance);
        });
      }

      if (this.map) {
        this.loading = false;
      }
    },
    buildCircles() {
      const { map } = this;
      if (this.circles && this.circles.length > 0) {
        this.circles.forEach((circle) => {
          this.mapCircles.push({
            strokeColor: circle.strokeColor,
            strokeOpacity: circle.strokeOpacity,
            strokeWeight: circle.strokeWeight,
            fillColor: circle.fillColor,
            fillOpacity: circle.fillOpacity,
            map,
            center: circle.center,
            radius: circle.radius,
          });
        });
      }
    },
    getDirectionsRoute(origin, destination) {
      this.markers.forEach((marker) => this.mapMarker[marker.id].setMap(null));
      this.mapCircles.forEach((circle, i) => this.circleInstances[i].setMap(null));
      const request = { origin, destination, travelMode: "DRIVING" };

      this.directions.route(request, (response, status) => {
        if (status == "OK") {
          this.directionsRenderer.setDirections(response);
          this.directionsRenderer.setMap(this.map);
          this.directionsRenderer.setPanel(document.getElementById("directionsPanel"));
          this.$emit("directions-rendered", true);
        }
      });
    },
    clearDirectionsRoute() {
      this.directionsRenderer.setMap(null);
      this.markers.forEach((marker) => this.mapMarker[marker.id].setMap(this.map));
      this.mapCircles.forEach((circle, i) => this.circleInstances[i].setMap(this.map));
      this.map.setZoom(this.zoom);
    },
    triggerBuyerPopupClick(locationId) {
      this.markers.forEach((marker) => {
        this.popups[marker.id]?.close();
      });
      this.popups[locationId].open(this.map, this.mapMarker[locationId]);
    },
    hidePopup(locationId) {
      this.popups[locationId].close();
    },
  },
};
</script>
